import { render, staticRenderFns } from "./insta-feed-detail-modal.vue?vue&type=template&id=5da236ea&"
import script from "./insta-feed-detail-modal.vue?vue&type=script&lang=js&"
export * from "./insta-feed-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Work\\AbdulMalikYoosufani\\BondhEShams\\BondhEShams\\BondhEShams.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5da236ea')) {
      api.createRecord('5da236ea', component.options)
    } else {
      api.reload('5da236ea', component.options)
    }
    module.hot.accept("./insta-feed-detail-modal.vue?vue&type=template&id=5da236ea&", function () {
      api.rerender('5da236ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue-app/public/components/instagram/insta-feed-detail-modal.vue"
export default component.exports